<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid>
				<div class="rule">
					<h1>プライバシーポリシー</h1>
					<dl class="dl-block">
						<p>
							{{shop_name}}（以下「当社」といいます）が提供するスマートフォン（以下「端末機」といいます）向けの公式アプリ（以下「本アプリ」といいます）は、企業活動の上で取り扱う個人情報について、法令等の諸規定を遵守したうえ、これを適切に管理、保護し、お客様及び取引先、並びに当社の事業に従事する役員及び社員等（以下、「従業者等」という。）の利害関係者が安心できる個人情報保護体制の運用・向上を目的として、個人情報の取扱に関する方針を以下のように定めます。
						</p><br>

						<dt>1. 法令等の遵守</dt>
						<dd>当社は、お客様の個人情報の取得、利用その他一切の取り扱いについて、個人情報の保護に関する法律、通信の秘密に係る電気通信事業法の規定その他の関連法令、各種ガイドライン（以下、「ガイドライン」）及びこのプライバシーポリシーを遵守します。</dd>
						
						<dt>2. 個人情報の取得・収集について</dt>
						<dd>
							本サービスを利用するために、または本サービスの利用を通じてお客様からご提供いただく情報は、本アプリを通じてお客様が入力または送信した情報で、以下の情報が含まれます。<br>
							・お客様の氏名、生年月日、ご連絡先等<br>
							・お客様がご利用になった本サービスの内容、日時、回数などのご利用内容・履歴・状況に関する情報<br>
							・お客様が本サービスに投稿した写真、動画、テキストのコンテンツ及びアクセス情報<br>
							・お客様の端末情報（お客様の識別に係る情報、通信サービス上の行動履歴、その他お客様のスマートフォン、PC等の端末においてお客様またはお客様の端末に関連して生成または蓄積された情報）<br>
							・その他本アプリで取得される、お客様に関する一切の情報<br>
							<p></p>
							これらの情報のうち、当社サービスを提供する上でご登録が必須となる各種情報について、当該情報をご提供いただけない場合には、当社サービスの全部または一部をご利用いただけないことがございます。<br>
							<p></p>
							アプリで取得する情報には、例えば、以下のようなものがあります。<br>
						</dd>
						
						<dt>3. アプリで取得する情報の具体例</dt>
						<dd>
							当社は、お客様が端末を操作してアプリを利用する際に、お客様から当社へデータをご提供いただく場合があります。<br>
							これらのデータには、以下のようなものが含まれます。<br>
							<p></p>
							・お客様のプロフィール情報（アイコン画像、アプリ会員ID等を含みます）。<br>
							・アプリ利用日時、回数、利用内容、履歴。スタンプカードやポイントカード機能では、お客様がアプリを利用した日時や回数を取得しています。オンラインチケット機能の支払いに利用するお客様のクレジットカード情報を取得しています。<br>
							・画像、テキストメッセージ。チャット機能では、お客様がアプリ上で当社とやり取りをする際に、端末上の画像や動画をアップロードできる機能を提供しています。なお、他のお客様などの第三者に公開されることはありません。<br>
							・位置情報。当社が取得した位置情報は、それに基づくコンテンツ配信（例えば、エリア限定の情報のプッシュ通知等）、当該アプリの機能提供のために、必要な範囲でのみ利用します。<br>
						</dd>
						
						<dt>4.取得した個人情報の利用目的について</dt>
						<dd>
							当社が個人情報を収集・利用する目的は、以下のとおりです。<br>
							・当社が販売する商品、提供するサービス、実施するキャンペーン等に関する情報提供のため<br>
							・取得した属性情報、閲覧・購買履歴等を分析してお客様の趣向に応じた情報提供、コンテンツ、クーポン、広告を配信するため<br>
							・当社が提供するサービスのユーザーサポートのため<br>
							・当社が提供するサービスに関連する規約やポリシー等(以下「規約等」といいます)に違反する行為に対応するため<br>
							・当社が提供するサービスを通じた取引、お問い合わせ、その他本サービスに関連したお客様への連絡のため<br>
							・当社が現在提供しているサービスまたは将来提供を検討しているサービスに関するマーケティング活動のため<br>
							・当社の商品開発およびサービス改善の統計データとして利用するため<br>
						</dd>
						
						<dt>5.利用目的の特定及び公表</dt>
						<dd>当社は、当社が取得したお客様の個人情報の利用目的を可能な限り特定の上、予め公表します。また、お客様から契約書等の書面に記載された個人情報を直接取得する場合は、予めお客様に対して利用目的を明示します。利用目的については、各サービスの所定のページをご覧下さい。</dd>
						
						<dt>6.第三者への提供</dt>
						<dd>当社は、法令に別段の定めがある場合を除き、お客様の同意を得ないで、第三者にお客様の個人情報を提供することはありません。当社のサービスをご利用いただくうえで第三者への提要が必要となる場合には、事前に、利用目的等を特定し公表したうえで、お客様の同意を得ることと致します。</dd>
						
						<dt>7.保存期間</dt>
						<dd>当社は、法令で別段の定めがある場合を除き、利用目的に必要な範囲内でお客様の個人情報の保存期間を定め、保存期間経過後又は利用目的達成後はお客様の個人情報を遅滞なく消去いたします。</dd>
						
						<dt>8.安全管理措置</dt>
						<dd>当社は、お客様の個人情報の取り扱いの全部又は一部を利用目的の範囲内で第三者に委託する場合があります。委託先の選定にあたっては、委託先が個人情報を適正に取り扱っていることを確認し、お客様の個人情報の適正な取り扱いを求めます。また、委託先との契約には個人情報の取り扱いの監査に関する項目を含めるなど委託先に対して必要且つ適切な監督を行います。</dd>

						<dt>9.従業者の監督</dt>
						<dd>当社は、お客様の個人情報の安全管理が図られるよう従業者に対する必要かつ適切な監督を行います。また、従業者に対して個人情報の適正な取り扱いの確保のために必要な教育研修を実施します。</dd>
						
						<dt>10.委託先の監督</dt>
						<dd>当社は、お客様の個人情報の取り扱いの全部又は一部を利用目的の範囲内で第三者に委託する場合があります。委託先の選定にあたっては、委託先が個人情報を適正に取り扱っていることを確認し、お客様の個人情報の適正な取り扱いを求めます。また、委託先との契約には個人情報の取り扱いの監査に関する項目を含めるなど委託先に対して必要且つ適切な監督を行います。</dd>

						<dt>11.開示等の請求等</dt>
						<dd>お客様が個人情報の利用目的の通知、又は個人情報の開示、又は訂正、追加若しくは削除又は利用の停止若しくは第三者への提供の停止を希望される場合は、当社所定の手続きに従ってご請求下さい。個人情報の開示等の請求手続は、当社お問い合わせ窓口までお問い合わせください。</dd>

						<dt>12.プライバシーポリシーの変更</dt>
						<dd>
							本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、お客様に通知することなく、変更することができるものとします。<br>
							当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本アプリに掲載したときから効力を生じるものとします。
						</dd>

						<dt>13. お問い合わせ窓口</dt>
						<dd>
						本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。<br>

						会社名 {{shop_name}}<br>
						問い合わせ先 {{tel}}<br>
						</dd>
	
						<p class="si">附則<br> 本規約は2024年4月12日から実施します。
						</p>
					</dl>
				</div>

			</v-container>
		</v-content>
	</v-app>
</template>

<script>
export default {
	data: () => ({
			shop_name: null,
  }),
  async created() {
    var shop_id = this.getUrlGetParam('shop_id')

    if(!shop_id){
      this.init = this.storageGet('*')
      shop_id = this.init.sid
    }

    try {
      //ページ表示に必要な情報を取得
      var shopReq = { params: {
        sid: shop_id
      }}
      var shopRes = await this.apiCall('/user/shop', shopReq)

      this.shop_name = shopRes.corporate_name
      this.tel = shopRes.tel

    } catch(e) {
      this.callDialog('エラー', shopRes.message, 3);
    }
  }
}
</script>

<style scoped>
h1 {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: #333;
	margin-bottom: 20px;
}

.rule {
	padding-top: 10px;
}

dl {
	font-size: 13px;
}

dt {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	text-align: center;
	color: #333;
	margin: 30px 0 10px;
}

.si {
	margin-top: 30px;
}
</style>
